module.exports = __webpack_public_path__ + "static/media/okBlue.2bfa5012.svg";